import React from 'react'
import { GiftHeader, GiftHeaderText, GiftHeaderContent } from '../styles/gift'
import { Title } from '../styles/elements'
import Image from '../styles/image'
import Header from './common/Header'
import PaidGiftHeader from './PaidGiftHeader'

export default ({
  background: {
    color,
    image
  },
  description: {
    title,
    summary
  },
  isPaid,
  code,
  purchaseDate,
  expirationDate,
  score,
  isGiftScrolled,
  type,
}) => (
  <>
    <Header
      score={score}
      backgroundColor={color}
      title={title}
      isGiftScrolled={isGiftScrolled}
      isSmall
    />
    <GiftHeader
      backgroundColor={color}
      height={isGiftScrolled ? 0 : '500px'}
      padding={isGiftScrolled && '0px'}
      hasShadow={isGiftScrolled}
    >
      <GiftHeaderContent
        opacity={isGiftScrolled ? 0 : 1}
      >
        <Image src={image} width="72px" filter="none" big />
        <Title color="#fff">{title}</Title>
        <GiftHeaderText>{summary}</GiftHeaderText>
        {isPaid &&
          <PaidGiftHeader
            purchaseDate={purchaseDate}
            expirationDate={expirationDate}
            code={code}
            type={type}
          />
        }
      </GiftHeaderContent>
    </GiftHeader>
  </>
)
